<div class="stripe-card" #stripeView>
  @if (stripeLoading) {
    <!-- Stripe ghost element start -->
    <div class="row skeleton-animation">
      <div class="d-flex gap-3">
        <div class="bar w-50"></div>
        <div class="bar w-25"></div>
        <div class="bar w-25"></div>
      </div>
      <div>
        <div class="bar mt-3"></div>
        <div class="bar mt-3"></div>
      </div>
    </div>
    <!-- Stripe ghost element end -->
  }

  <!--
    Stripe Elements render into a LIGHT-DOM node that is projected here. The node is a direct child
    of the custom element carrying `slot="<slotName>"`; see `projectStripeIntoLightDom()`. Hiding
    this wrapper hides the projected content with it, because layout follows the flattened tree.
  -->
  <div [class.d-none]="stripeLoading">
    <slot [attr.name]="slotName"></slot>
  </div>

  @if (errorMessage) {
    <div class="alert alert-danger summary-warning mt-2" role="alert" aria-live="assertive">{{ errorMessage }}</div>
  }
</div>

<!--
  Declared here so its bindings resolve against this component, but never rendered in place - the
  view is created manually and its root nodes are moved into the slotted light-DOM host.
-->
<ng-template #stripeElements>
  @if (elementsOptions?.clientSecret) {
    <ngx-stripe-elements [stripe]="stripe" [elementsOptions]="elementsOptions">
      <ngx-stripe-payment (ready)="onReady()" (loaderror)="onLoadError($event)" />
    </ngx-stripe-elements>
  }
</ng-template>
